import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ApplicationStateApiService } from '../services/application-state-api-service';
import { SignalR, SignalRConnection, IConnectionOptions } from 'ng2-signalr';

@Injectable()
export class ApplicationStateManagerService implements OnDestroy
{
    routerEventsSubscription: Subscription;

    private maxMobileWindowWidth = 600;
    private _isHamburgerMenuExpanded = false;
    private _mailCenterIsDisplayed = false;
    private _previousRouteUrl: string;
    private _currentRouteUrl: string;
    isFixturePreviewRunning= new Subject();
    windowResize = new Subject();

    constructor(private applicationStateService: ApplicationStateApiService,
                private router: Router,
                private _signalR: SignalR)
    {
        // Monitor router navigation
        this.routerEventsSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) =>
            {
                this.updateRoutes(event.url);
            });
    }

    ngOnDestroy(): void
    {
        this.routerEventsSubscription.unsubscribe();
    }

    updateRoutes(currentRouteUrl: string)
    {
        this._previousRouteUrl = this._currentRouteUrl;
        this._currentRouteUrl = currentRouteUrl;
    }

    get currentRouteUrl(): string
    {
        return this._currentRouteUrl;
    }

    get previousRouteUrl(): string
    {
        return this._previousRouteUrl;
    }

    get isMobileWindowWidth(): boolean
    {
        return window.innerWidth <= this.maxMobileWindowWidth;
    }

    get isHamburgerMenuExpanded(): boolean
    {
        return this._isHamburgerMenuExpanded;
    }

    set isHamburgerMenuExpanded(isExpanded: boolean)
    {
        this._isHamburgerMenuExpanded = isExpanded;
    }

    get mailCenterIsDisplayed(): boolean
    {
        return this._mailCenterIsDisplayed;
    }

    set mailCenterIsDisplayed(isDisplayed: boolean)
    {
        this._mailCenterIsDisplayed = isDisplayed;
    }

    healthCheck(): Observable<any>
    {
        // this.connect();
        return this.applicationStateService.healthCheck();
    }

    resizeWindow()
    {
        this.windowResize.next();
    }

    connect() {
        let o: IConnectionOptions = { hubName: 'notificationhub' };
        let conx = this._signalR.createConnection(o);
        conx.status.subscribe((s) => console.warn(s));
        conx.start().then((c) => {

            let listener = c.listenFor('healthCheck');
            listener.subscribe((data) => {
                console.log(data);

            });
        });
    }
}
